<template>
  <w-app>
    <w-flex class="justify-center align-center">
      <main>
        <router-view :user="user" v-slot="{ Component }">
          <keep-alive include="Home">
            <component :is="Component"/>
          </keep-alive>
        </router-view>
      </main>
    </w-flex>
  </w-app>
</template>

<script>
import {auth} from '../components/util.js'

export default {
  name: 'App',
  components: {
  },
  props: {
  },
  async setup(props){
    var user = await auth();
    return { user };
  }
}
</script>

<style>
@font-face {
  font-family: "Open Sans";
  src: local("Open Sans"),
   url(../fonts/OpenSans/OpenSans-Regular.ttf) format("truetype");
}

.w-app{
  font-family: "Open Sans";
}

.break {
  flex-basis: 100%;
  height: 0;
}
</style>
